import React, { FC, useEffect } from 'react';
import { isUndefined } from 'lodash';

import { IInput } from '../../types/global';

type TChecked = string | number | boolean | undefined;

interface IPropsOption {
  id?: string;
  value?: string;
  title: string;
  isChecked: boolean;
  handleChecked: (checked: TChecked) => void;
}

export interface IPropsRadio extends IInput.IProps {
  options: any[];
  name: string;
  value: TChecked;
}

const Radio: FC<IPropsRadio> = ({ options, onChange, name, value }) => {
  const [valueState, setValueState] = React.useState<TChecked>(value);

  const handleChecked = (checked: any) => {
    setValueState(checked);
    onChange({ target: { name, value: checked } });
  };

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return (
    <div className="tw-mt-4">
      {options.map((optionItem) => (
        <RadioItem
          key={optionItem.id || optionItem.value}
          isChecked={!isUndefined(valueState) && valueState === optionItem.value}
          handleChecked={handleChecked}
          {...optionItem}
        />
      ))}
    </div>
  );
};

const RadioItem: FC<IPropsOption> = ({ title, value, id, isChecked, handleChecked }) => {
  return (
    <div
      className="tw-mb-[0.125rem] tw-block tw-min-h-[1.5rem] tw-cursor-pointer tw-pl-0"
      onClick={() => handleChecked(id || value)}
    >
      {isChecked ? (
        <span className="icon-Checkbox-and-Radio-Buttons">
          <span className="path1" />
          <span className="path2" />
          <span className="path3" />
        </span>
      ) : (
        <span className="icon-Checkbox-and-Radio-Buttons1" />
      )}
      <label
        className="tw-mt-px tw-inline-block tw-text-gray0 tw-ml-2 tw-hover:cursor-pointer"
        htmlFor={`radio${id || value}`}
      >
        {title}
      </label>
    </div>
  );
};

export { Radio };
